/*
 * @Autor: 杨华
 * @Version: 1.0
 * @Date: 2020-07-10 10:02:05
 * @LastEditors: xx
 * @Description:
 * @LastEditTime: 2020-12-25 14:15:10
 */

import { request } from "./api-require";
import { objAny } from "../common/common-interface";
const API_URL = "/oms-interconnection-service/v1";
//分页获取互联互通服务
export const getInterflowList = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/interflow/page", data, config);
};
//互联互通-审核系统信息
export const auditOprSystem = (data = {}, config: objAny = {}) => {
  config.method = "postStr";
  return request(API_URL + "/interflow/audit_opr_system", data, config);
};

//互联互通-获取协议下拉框选择
export const getProtocolList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/interflow/get_protocol", data, config);
};
